<div class="d-flex align-items-center justify-content-between mt-3" style="height: 31px;">
  <div class="blue-grey-text font-weight-bold d-flex align-items-center">
    <i class="fa-lg fa-fw far fa-comment-alt {{color}}-text mr-1"></i>
    <div class="mx-1">{{ 'DATALABELS' | translate }}</div>
    <mdb-badge info="true" class="z-depth-0">#&nbsp;{{ current.index }}</mdb-badge>
  </div>
  <div class="btn-group" mdbDropdown>
    <button mdbDropdownToggle type="button" size="sm" mdbBtn color="light" class="blue-grey-text z-depth-0 dropdown-toggle waves-light d-flex align-items-center px-3" mdbWavesEffect>
      <i class="far fa-bars"></i>&nbsp;
    </button>
  
    <div class="dropdown-menu dropdown-dark dropdown-menu-right">

      <a class="dropdown-item z-depth-0" (click)="editorIndex = 0">{{ 'TO_DISPLAY' | translate }}</a>
      <a class="dropdown-item z-depth-0" (click)="editorIndex = 1">{{ 'POSITION' | translate }}</a>
      <a class="dropdown-item z-depth-0" (click)="editorIndex = 2">{{ 'FONT' | translate }}</a>
      <a class="dropdown-item z-depth-0" (click)="editorIndex = 3">{{ 'BORDER' | translate }}</a>

    </div>
  </div>
</div>

<hr>

<div class="alert alert-info font-weight-bolder font-extra-small" role="alert">
  {{ 'DATALABELS_MUST_BE_ASSIGNED/TEXT' | translate }}
</div>

<hr>

<div [ngSwitch]="editorIndex">
  <div *ngSwitchCase="0">
    <app-editor-section-title [title]="'SETTINGS'" (sendNext)="receiveNext($event)"></app-editor-section-title>

    <app-theme-option-datalabels-display [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-display>
    <app-theme-option-datalabels-opacity [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-opacity>
    <app-theme-option-datalabels-rotation [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-rotation>
    <app-theme-option-datalabels-padding [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-padding>
    <app-theme-option-datalabels-background-color [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-background-color>

  </div>
  <div *ngSwitchCase="1">
    <app-editor-section-title [title]="'POSITION'" (sendNext)="receiveNext($event)"></app-editor-section-title>

    <app-theme-option-datalabels-anchor [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-anchor>
    <app-theme-option-datalabels-align [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-align>
    <app-theme-option-datalabels-clamp [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-clamp>
    <app-theme-option-datalabels-clip [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-clip>
    <app-theme-option-datalabels-offset [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-offset>

  </div>
  <div *ngSwitchCase="2">
    <app-editor-section-title [title]="'FONT'" (sendNext)="receiveNext($event)"></app-editor-section-title>

    <app-theme-option-datalabels-font-family [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-font-family>
    <app-theme-option-datalabels-font-size [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-font-size>
    <app-theme-option-datalabels-font-style [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-font-style>
    <app-theme-option-datalabels-color [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-color>
    <app-theme-option-datalabels-font-line-height [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-font-line-height>
    <app-theme-option-datalabels-text-shadow-blur [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-text-shadow-blur>
    <app-theme-option-datalabels-text-shadow-color [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-text-shadow-color>
    <app-theme-option-datalabels-text-stroke-width [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-text-stroke-width>
    <app-theme-option-datalabels-text-stroke-color [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-text-stroke-color>

  </div>
  <div *ngSwitchCase="3">
    <app-editor-section-title [title]="'BORDER'" (sendNext)="receiveNext($event)"></app-editor-section-title>
    
    <app-theme-option-datalabels-border-width [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-border-width>
    <app-theme-option-datalabels-border-color [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-border-color>
    <app-theme-option-datalabels-border-radius [themeOptions]="themeOptions" [datalabelsIndex]="current.index"></app-theme-option-datalabels-border-radius>

  </div>
</div>